import { useTranslation } from 'react-i18next';

import CloseSVG from '@/assets/icons/close.svg';
import { Button, ButtonVariant } from '@/components/form/button';

interface IProps {
  message?: JSX.Element | string;

  /** use this callback to clear out error message */
  close?: () => void;
}

export const ErrorAlert: React.FC<IProps> = ({ message, close }) => {
  const { t } = useTranslation();
  if (!message) return null;

  return (
    <div className="flex justify-between bg-wine-light text-red-light text-sm font-semibold p-4 rounded-md w-full">
      {typeof message === 'string' ? t(message) : message}

      <div>
        <Button variant={ButtonVariant.Link} onClick={close}>
          <img src={CloseSVG} alt="close" className="w-3 h-3" />
        </Button>
      </div>
    </div>
  );
};
